(function () {
  function hideVariantDescriptions() {
    // NOTE: getElementsByClassName takes the class name WITHOUT the dot
    var els = document.getElementsByClassName('product__description__variant');
    if (!els || !els.length) return;
    Array.prototype.forEach.call(els, function (el) {
      el.classList.add('visually-hidden');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideVariantDescriptions);
  } else {
    hideVariantDescriptions();
  }

  // Re-run if theme sections re-render (editor/dynamic sections)
  document.addEventListener('shopify:section:load', hideVariantDescriptions);
  document.addEventListener('shopify:section:select', hideVariantDescriptions);
})();